import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "../../../types";
import { addReview, addReviewDesktop } from "../../../apis";
import { Storage } from "common/storage";

export function usePostVenueReview(isDesktop?: boolean) {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      venueId,
      review,
      images,
      selectedAnswer,
    }: {
      images: AddPhotoImageData[];
      venueId: string;
      review: string;
      selectedAnswer: string;
    }) => {
      return isDesktop
        ? addReviewDesktop(
            venueId,
            review,
            images,
            selectedAnswer,
            accessToken || ""
          )
        : addReview(
            venueId,
            review,
            images,
            selectedAnswer,
            accessToken || ""
          );
    },
    onSuccess: (_, { venueId }) => {
      console.log("usePostVenueReview onSuccess");
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["loadVenueDetailsBySlug"],
          exact: false,
        });
      }, 2000);
    },
  });

  return { mutate, error, status, data };
}
